import { Component, OnInit } from '@angular/core';
import { ICompany } from '../shared/Domains/company';
import { ActivatedRoute } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { BreadcrumbService } from '../breadcrumb.service';
import { AppServiceManager } from 'common/services/appServiceManager';
import { ISettings } from '../shared/Domains/settings';
import { AuthService } from 'common/services/auth.service';
import { IFormFields } from '../shared/Domains/IFormFields';
import { IUser } from '../shared/Domains/IUser';
import { LanguageService } from 'app/LanguageService/Language.Service';
@Component({
  selector: 'app-global',
  templateUrl: './global.component.html',
  styleUrls: ['./global.component.css']
})
export class GlobalComponent implements OnInit {
  company: ICompany;
  display: boolean;
  setting: ISettings;
  memberFormFields:IFormFields[] = [];
  memberFieldDialogVisibility: boolean = false;
  loading: boolean = false;
  user: IUser;

  constructor(private LanguageService: LanguageService, private route: ActivatedRoute, private confirmationService: ConfirmationService, private messageService: MessageService, private breadcrumbService: BreadcrumbService, private appServiceManager: AppServiceManager) {
    this.breadcrumbService.setItems([
      { label: 'Global Settings' }
    ]);
  }
	setLabel(label) {
    return this.LanguageService.GetCurrentLanguage("GlobalComponent", label);
  }
  ngOnInit() {
    this.setting = new ISettings();
    this.company = new ICompany();
    this.user = new IUser();
    this.company._id = AuthService.getLoggedInCompany();
    this.user.branch = AuthService.getLoggedInBranch();
    this.getCompany();
    // this.getFormFields();
  }
  getCompany() {
    this.company = AuthService.getLoggedInCompanyBranch();
    if(!this.company){
    this.appServiceManager.get('companies/' + this.company._id).subscribe((res) => {
      if (res) {
        this.company = res;
        if (this.company.globalSetting) {
          this.setting = this.company.globalSetting;
          this.setting.dueDate = new Date(this.setting.dueDate);
          this.setting.gymStartingDate = new Date(this.setting.gymStartingDate);
        } else {
          this.setting = new ISettings();
        }
      } else {
        this.company = new ICompany();
        this.messageService.clear();
        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
      }
    },
      (error) => {
        this.company = new ICompany();
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      });
    }
  }

  // getFormFields(){
  //     this.memberFormFields = [];
  //     this.loading = true;
  //     this.appServiceManager.get('companies/formFields/' + 'branch/' + this.user.branch).subscribe((res) => {
  //       if (res.length > 0) {
  //         this.memberFormFields = res.sort((a, b) => { return <any>new Date(b.createdDate) - <any>new Date(a.createdDate) });
  //         this.loading = false;
  //       } else{
  //         this.loading = false;
  //         this.messageService.clear();
  //         this.messageService.add({ severity: 'info', summary: 'Info Message', detail: "No Record Found" });
  //       }

  //     },
  //       (error) => {
  //         this.loading = false;
  //         this.messageService.clear();
  //         this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
  //       });

  // }

  update() {
    this.confirmationService.confirm({
      message: "Are you sure you want to update Settings ?",
      accept: () => {
        this.company.globalSetting = this.setting;
        this.appServiceManager.put("companies/" + this.company._id, this.company).subscribe((res: any) => {
          if (res) {
            this.company = res.company;
            this.messageService.clear();
            this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Global Settings Successfully Updated' });
          } else {
            this.messageService.clear();
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
          }
        },
          (error) => {
            this.messageService.clear();
            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
          });
      }
    });
  }
}
